(function () {
  function forceVisible(selector) {
    document.querySelectorAll(selector).forEach(function (element) {
      if (window.getComputedStyle(element).display === 'none') {
        element.style.display = 'block';
      }
    });
  }

  function disableInactiveCountryOverlays() {
    document.querySelectorAll('.country-selector__overlay').forEach(function (overlay) {
      var panel = overlay.previousElementSibling;
      var isHiddenPanel =
        panel &&
        panel.classList &&
        panel.classList.contains('country-selector') &&
        panel.hasAttribute('hidden');

      if (!panel || isHiddenPanel) {
        overlay.style.display = 'none';
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
      }
    });
  }

  function hydrateHomepageNewsletter() {
    if (window.location.pathname !== '/') return;

    var heroNewsletter = Array.from(document.querySelectorAll('section, .shopify-section')).find(function (section) {
      return /Get 10% off your first order/i.test(section.textContent || '');
    });

    if (!heroNewsletter || heroNewsletter.querySelector('input[type="email"]')) return;

    var heroWrapper = heroNewsletter.querySelector('.newsletter__wrapper');
    var footerForm = document.querySelector('#ContactFooter') || document.querySelector('.footer__newsletter.newsletter-form');

    if (!heroWrapper || !footerForm) return;

    var clonedForm = footerForm.cloneNode(true);
    clonedForm.id = 'ContactHomepageNewsletter';

    var input = clonedForm.querySelector('input[type="email"]');
    var label = clonedForm.querySelector('label[for]');

    if (input) {
      input.id = 'NewsletterForm--homepage-fallback';
      input.value = '';
      input.removeAttribute('aria-describedby');
      input.removeAttribute('aria-invalid');
      input.removeAttribute('autofocus');
    }

    if (label) {
      label.setAttribute('for', 'NewsletterForm--homepage-fallback');
    }

    clonedForm.querySelectorAll('.newsletter-form__message').forEach(function (message) {
      message.remove();
    });

    heroWrapper.appendChild(clonedForm);
    heroWrapper.classList.add('moxi-homepage-newsletter-ready');

    heroNewsletter.querySelectorAll('shop-login-button, [class*="shop-login"], .footer__follow-on-shop').forEach(function (element) {
      element.remove();
    });
  }

  function applyHomepageFixes() {
    disableInactiveCountryOverlays();

    if (window.location.pathname !== '/') return;

    [
      '.mx-color-item__fill',
      '.mx-color-item__shine',
      '.mx-color-item__pupil',
      '.mx-series__card-fallback',
      '.mx-series__card-overlay',
      '.mx-hero__overlay',
      '.mx-hero__scroll-line',
    ].forEach(forceVisible);

    document.querySelectorAll('.mx-color-item__fill').forEach(function (element) {
      var rect = element.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        element.style.width = '100%';
        element.style.height = '100%';
      }
    });

    var heroHeading = document.querySelector('.mx-hero__heading');
    if (heroHeading && heroHeading.textContent.indexOf('worldin') !== -1) {
      heroHeading.textContent = heroHeading.textContent.replace('worldin', 'world in');
    }

    var storyButton = Array.from(document.querySelectorAll('a')).find(function (link) {
      return /Learn Our Story/i.test(link.textContent || '');
    });
    if (storyButton && storyButton.getAttribute('href') === '/pages/about') {
      storyButton.setAttribute('href', '/pages/about-us');
    }

    var storyInner = document.querySelector('.mx-story__inner');
    var storyMedia = document.querySelector('.mx-story__media');
    var storyPlaceholder = storyMedia && storyMedia.querySelector('.mx-story__img-placeholder');
    var storyImage = storyMedia && storyMedia.querySelector('img');
    if (storyInner && storyMedia && storyPlaceholder && !storyImage) {
      storyMedia.remove();
      storyInner.classList.add('mx-story__inner--no-media');
    }

    hydrateHomepageNewsletter();
  }

  var rerunDelays = [250, 1000, 2500, 5000];

  rerunDelays.forEach(function (delay) {
    window.setTimeout(applyHomepageFixes, delay);
  });

  var observer = new MutationObserver(applyHomepageFixes);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHomepageFixes);
  } else {
    applyHomepageFixes();
  }
})();
